module.exports = __webpack_public_path__ + "static/img/f_first_01.848209e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_01.png
// module id = qz26
// module chunks = 9